import { calculateStandardPayment } from '../payment-calculations';
import { usd } from '../money';
import { PromoOffer, Duration } from '../types';

export const DEFAULT_MAX_CART_SIZE = 1000000;

export const EXAMPLE_TOTAL_PRICE = usd(100000);
export const EXAMPLE_INSTALMENT_RATE = 0.2199;
export const EXAMPLE_INSTALMENT_NUM_PAYMENTS = 12;
export const EXAMPLE_INSTALMENT_FREQUENCY: Duration = {
  length: 12,
  designator: 'M',
};

export const EXAMPLE_SPLITPAY_RATE = 0;
export const EXAMPLE_SPLITPAY_NUM_PAYMENTS = 4;
export const EXAMPLE_SPLITPAY_FREQUENCY: Duration = {
  length: 4,
  designator: 'W',
};

export const EXAMPLE_INSTALLMENTS_PROMO_OFFER: PromoOffer = {
  type: 'INSTALLMENTS',
  numberOfPayments: EXAMPLE_INSTALMENT_NUM_PAYMENTS,
  rate: EXAMPLE_INSTALMENT_RATE,
  frequency: EXAMPLE_INSTALMENT_FREQUENCY,
  paymentAmount: calculateStandardPayment({
    principal: EXAMPLE_TOTAL_PRICE.value,
    interestRate: EXAMPLE_INSTALMENT_RATE,
    termLength: EXAMPLE_INSTALMENT_NUM_PAYMENTS,
    duration: EXAMPLE_INSTALMENT_FREQUENCY,
  }),
};

// TODO HYLOC - Validate this is correct
export const EXAMPLE_HYBRID_LINE_OF_CREDIT_PROMO_OFFER: PromoOffer = {
  type: 'HYBRID_LINE_OF_CREDIT',
  numberOfPayments: EXAMPLE_INSTALMENT_NUM_PAYMENTS,
  rate: EXAMPLE_INSTALMENT_RATE,
  frequency: EXAMPLE_INSTALMENT_FREQUENCY,
  paymentAmount: calculateStandardPayment({
    principal: EXAMPLE_TOTAL_PRICE.value,
    interestRate: EXAMPLE_INSTALMENT_RATE,
    termLength: EXAMPLE_INSTALMENT_NUM_PAYMENTS,
    duration: EXAMPLE_INSTALMENT_FREQUENCY,
  }),
};

export const EXAMPLE_SPLITPAY_PROMO_OFFER: PromoOffer = {
  type: 'SPLITPAY',
  numberOfPayments: EXAMPLE_SPLITPAY_NUM_PAYMENTS,
  rate: EXAMPLE_SPLITPAY_RATE,
  frequency: EXAMPLE_INSTALMENT_FREQUENCY,
  paymentAmount: calculateStandardPayment({
    principal: EXAMPLE_TOTAL_PRICE.value,
    interestRate: EXAMPLE_SPLITPAY_RATE,
    termLength: EXAMPLE_SPLITPAY_NUM_PAYMENTS,
    duration: EXAMPLE_SPLITPAY_FREQUENCY,
  }),
};
